"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M4.77747 9.18506C5.21548 9.18506 5.57056 8.82998 5.57056 8.39197C5.57056 7.95396 5.21548 7.59888 4.77747 7.59888C4.33945 7.59888 3.98438 7.95396 3.98438 8.39197C3.98438 8.82998 4.33945 9.18506 4.77747 9.18506Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M3.58789 2.44393C4.38098 1.25423 6.12228 1.16802 6.76026 2.44393C6.9585 2.84041 7.15681 4.03008 5.96717 4.62486C4.77753 5.21964 4.77753 5.46684 4.77753 6.01281",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

exports.default = Icon;